import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.flat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.unscopables.flat.js";
import "core-js/modules/es.array.unshift.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import moment from "moment";
var fileDownload = require("js-file-download");
import { request } from "@/js/http/http_request";
import { hasRole, isAccessTokenExpired, isAdminNotConsultant, isConsultantOrHolding, isConsultantNotHolding, isHolding, isPricePostingUsaProSubmittedByPriceCoherence, getLoggedUserData, getUserLogged, isSalesman, getClientAppData } from "@/js/http/auth.js";
import { listUserGroups, listContinents, listCurrencies, listWineTypes, bottlings, COUNTRIES, pricePostingStatusList } from "@/js/lists.ts";
import { getFullNameUser } from "@/js/user/user.js";
import { filterVAutocomplete, getErrorData, handleErrorData } from "@/js/forms.js";
import { formRules } from "@/js/form_rules.js";
import { filterDecimal2digitsKey } from "@/js/events/keycodes.js";
import SendInvitationAsConsultantModal from "@/components/user/SendInvitationAsConsultantModal.vue";
export default {
  name: "exportPriceList",
  components: {
    SendInvitationAsConsultantModal: SendInvitationAsConsultantModal
  },
  data: function data() {
    return {
      clientAppData: null,
      canAddCogsColumn: false,
      type: null,
      winerySearchInput: "",
      loggedUserData: {},
      exportingStatusList: {
        PREPARATION: {
          id: 0,
          label: "Preparation"
        },
        EXPORTING: {
          id: 1,
          label: "Export in progress"
        },
        EXPORT_COMPLETED: {
          id: 2,
          label: "Export completed"
        },
        ERROR: {
          id: 3,
          label: "An error occurred"
        },
        WAITING_EMAIL: {
          id: 4,
          label: "Waiting for email"
        }
      },
      exportTypesList: {
        EXPORT_FILE: {
          id: 0
        },
        MAIL_ATTACHMENT: {
          id: 1
        }
      },
      exportingStatus: null,
      formConfig: {
        countryId: null,
        stateId: null,
        userGroup: null,
        userIdTarget: null,
        pricePostingUsaProId: null,
        locations: null,
        originCountryId: null,
        originRegionId: null,
        producersId: [],
        bottlings: [],
        search: "",
        isWineIdColumn: false,
        isCogsColumn: false,
        isStockOnly: false,
        currency: null,
        productTypesId: [],
        productTypesIdExcluded: [],
        priceRange: {
          min: null,
          max: null
        },
        valid: false
      },
      isLoadingImplantedCountries: false,
      implantedCountries: [],
      listStates: [],
      displayedListStates: [],
      userBuyerGroups: [],
      userLogged: {},
      isLoadingProducers: false,
      listProducers: [],
      displayedListProducers: [],
      hasRoleThirdParty: false,
      isLoadingUserList: false,
      thirdPartyUserList: [],
      isLoadingWarehouses: false,
      fakeDirectWineryWarehouseId: 0,
      warehouses: [],
      isLoadingStorageLocations: false,
      storageLocationsForUser: [],
      isLoadingOrigins: false,
      listCountries: [],
      listRegions: [],
      displayedListRegions: [],
      gettingPricePostingUsaProPosted: {
        isPending: false,
        items: []
      },
      managedExceptions: {
        warning: {
          no_user_for_config: "There is no active member for this configuration. The export can't be completed."
        }
      },
      bottlings: bottlings,
      listWineTypes: listWineTypes,
      formRules: formRules
    };
  },
  computed: {
    isAuthorized: function isAuthorized() {
      return this.$whitelabel.isExportPriceList;
    },
    isStateRequired: function isStateRequired() {
      return (this.formConfig.userGroup === "HORECA" || this.formConfig.userGroup === "WHOLESALER") && this.formConfig.countryId === 226;
    },
    storageLocations: function storageLocations() {
      if (isAdminNotConsultant(this.loggedUserData)) {
        return [].concat(_toConsumableArray(this.warehouses.reduce(function (acc, x) {
          return [].concat(_toConsumableArray(acc), [{
            ids: [x.id_warehouse],
            name: x.name + " - " + listContinents.find(function (y) {
              return y.id === x.address.country.continent_iso_2;
            }).display_name
          }]);
        }, [])), [{
          ids: [this.fakeDirectWineryWarehouseId],
          name: "Direct producer"
        }]);
      } else {
        var array = this.storageLocationsForUser.reduce(function (acc, x) {
          var key = x.continent_iso2;
          if (acc.some(function (y) {
            return y.continent_iso_2 === key;
          })) {
            acc.find(function (y) {
              return y.continent_iso_2 === key;
            }).ids.push(x.warehouseId);
          } else {
            acc.push({
              continent_iso_2: key,
              name: x.name,
              ids: [x.warehouseId]
            });
          }
          return acc;
        }, []);
        return [].concat(_toConsumableArray(array), [{
          ids: [this.fakeDirectWineryWarehouseId],
          name: "Direct producer"
        }]);
      }
    },
    filename: function filename() {
      var _this2 = this;
      var value = "PLATFORM_PRICE_LIST";
      if (isAdminNotConsultant(this.loggedUserData)) {
        value += (this.formConfig.isCogsColumn ? "_WITH_COGS_DONT_SEND" : "") + "_";
        if (!!this.formConfig.userGroup) {
          value += String.replaceNonAlphaNumerics(this.implantedCountries.find(function (x) {
            return x.id_country == _this2.formConfig.countryId;
          }).printable_name.toUpperCase(), "_") + "_" + this.userBuyerGroups.find(function (x) {
            return x.id == _this2.formConfig.userGroup;
          }).name.toUpperCase();
        } else {
          value += this.thirdPartyUserList.find(function (x) {
            return x.id_user == _this2.formConfig.userIdTarget;
          }).name_for_file;
        }
      } else if (isConsultantOrHolding(this.loggedUserData)) {
        if (this.formConfig.userIdTarget) {
          value += "_" + this.thirdPartyUserList.find(function (x) {
            return x.id_user == _this2.formConfig.userIdTarget;
          }).name_for_file;
        }
      }
      return value + ".xlsx";
    },
    canChooseCurrency: function canChooseCurrency() {
      return isAdminNotConsultant(this.loggedUserData) && this.formConfig.countryId && this.formConfig.countryId !== COUNTRIES.USA.id && this.countryDefaultCurrency !== null && this.countryDefaultCurrency !== "EUR";
    },
    listDefaultCurrencies: function listDefaultCurrencies() {
      var availableCurrencies = [];
      if (this.formConfig.countryId === COUNTRIES.USA.id) {
        availableCurrencies = ["USD"];
      } else if (this.formConfig.countryId === COUNTRIES.BAHAMAS.id) {
        availableCurrencies = ["BSD", "USD"];
      } else {
        availableCurrencies.push("EUR");
        availableCurrencies.push(this.countryDefaultCurrency);
      }
      return listCurrencies.filter(function (x) {
        return availableCurrencies.includes(x.id);
      });
    },
    countryDefaultCurrency: function countryDefaultCurrency() {
      var _this3 = this;
      return this.implantedCountries.find(function (x) {
        return x.id_country === _this3.formConfig.countryId;
      }).currency;
    },
    isSpiritsExport: function isSpiritsExport() {
      return this.type && this.type === "spirits";
    },
    implantedCountriesForConsultant: function implantedCountriesForConsultant() {
      var _this$implantedCountr,
        _this$thirdPartyUserL,
        _this$implantedCountr2,
        _this4 = this;
      if (((_this$implantedCountr = this.implantedCountries) === null || _this$implantedCountr === void 0 ? void 0 : _this$implantedCountr.length) == 0 || ((_this$thirdPartyUserL = this.thirdPartyUserList) === null || _this$thirdPartyUserL === void 0 ? void 0 : _this$thirdPartyUserL.length) == 0) return [];
      return _toConsumableArray((_this$implantedCountr2 = this.implantedCountries) === null || _this$implantedCountr2 === void 0 ? void 0 : _this$implantedCountr2.filter(function (x) {
        var _this4$thirdPartyUser;
        return (_this4$thirdPartyUser = _this4.thirdPartyUserList) === null || _this4$thirdPartyUser === void 0 ? void 0 : _this4$thirdPartyUser.map(function (u) {
          return u.delivery_address.country.id_country;
        }).some(function (countryId) {
          return countryId === x.id_country;
        });
      }));
    },
    canChoosePricePosting: function canChoosePricePosting() {
      var _this5 = this;
      if (this.hasRoleThirdParty) {
        var isTargetProUsaNotPennsylvania = (this.formConfig.userGroup === "HORECA" || this.formConfig.userGroup === "WHOLESALER") && this.formConfig.countryId === 226 && this.formConfig.stateId !== 45;
        var isTargetUserSubmittedPricePosting = false;
        if (this.formConfig.userIdTarget > 0) {
          var userTargeted = this.thirdPartyUserList.find(function (x) {
            return x.id_user === _this5.formConfig.userIdTarget;
          });
          isTargetUserSubmittedPricePosting = userTargeted.isPricePostingUsaProSubmittedByPriceCoherence;
        }
        return isTargetProUsaNotPennsylvania || isTargetUserSubmittedPricePosting;
      } else {
        return isPricePostingUsaProSubmittedByPriceCoherence(this.loggedUserData);
      }
    },
    isAnyFilterLoading: function isAnyFilterLoading() {
      return this.isLoadingUserList || this.isLoadingImplantedCountries || this.isLoadingOrigins || this.isLoadingWarehouses || this.isLoadingProducers || this.isLoadingStorageLocations || this.gettingPricePostingUsaProPosted.isPending;
    },
    getWineTypes: function getWineTypes() {
      return listWineTypes.filter(function (x) {
        return x.name !== "Spirit";
      });
    }
  },
  watch: {
    "formConfig.userIdTarget": function formConfigUserIdTarget(newVal, oldVal) {
      this.fetchStorageLocationsForUser();
    }
  },
  created: function created() {
    var _this6 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var _this6$formConfig$pro, _this;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!isAccessTokenExpired()) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return");
          case 2:
            _this6.hasRoleThirdParty = hasRole(process.env.VUE_APP_ROLES_THIRD_PARTY_ORDER);
            _this6.canAddCogsColumn = hasRole(process.env.VUE_APP_ROLES_MANAGE_WINE_COGS);
            _this6.type = _this6.$route.query.type;
            _this6.loggedUserData = getLoggedUserData();
            _this6.clientAppData = getClientAppData(_this6);
            _this6.init();
            if (_this6.isSpiritsExport) {
              _this6.formConfig.productTypesId.push(listWineTypes.find(function (x) {
                return x.name === "Spirit";
              }).id);
              (_this6$formConfig$pro = _this6.formConfig.productTypesIdExcluded).push.apply(_this6$formConfig$pro, _toConsumableArray(listWineTypes.filter(function (x) {
                return x.name !== "Spirit";
              }).map(function (x) {
                return x.id;
              })));
            } else {
              _this6.formConfig.productTypesIdExcluded.push(listWineTypes.find(function (x) {
                return x.name === "Spirit";
              }).id);
            }
            _this = _this6;
            getUserLogged().then(function (data) {
              _this.userLogged = data;
            });
            _this6.fetchWarehouses();
            _this6.fetchOriginCountriesAndRegions();
            if (isAdminNotConsultant(_this.loggedUserData) || isConsultantOrHolding(_this.loggedUserData)) {
              _this6.fetchUserList();
              _this6.fetchProducers();
              _this6.fetchImplantedCountries();
            }
            _this6.fetchPricePostingUsaProUsables();
            if (isAdminNotConsultant(_this.loggedUserData)) {
              _this.userBuyerGroups = listUserGroups.filter(function (x) {
                return x.id == "HORECA" || x.id == "WHOLESALER" || x.id == "USER";
              });
            } else {
              _this.userBuyerGroups = listUserGroups.filter(function (x) {
                return x.id == "HORECA" || x.id == "USER";
              });
              _this6.fetchStorageLocationsForUser();
            }
          case 16:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    openSendInvitationAsConsultantModal: function openSendInvitationAsConsultantModal() {
      this.$refs.SendInvitationAsConsultantModal.open();
    },
    init: function init() {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this7.exportCriterias = {};
              _this7.exportingStatus = _this7.exportingStatusList.PREPARATION.id;
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    //Sync with ThirdParyUserSelector ! Don't use ThirdParyUserSelector/TargetSelector components here, without evolutions, to not conflict with ccurrentCart
    fetchUserList: function fetchUserList() {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _this, response, values, _userLogged$delivery_, _userLogged$company_n, userLogged;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this8.isLoadingUserList = true;
              _this = _this8;
              _context3.next = 4;
              return request("/v1/third-party-users", "get", {}, true, "api").catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to get load customers");
                handleErrorData(_this, errorData);
                _this.isLoadingUserList = false;
                throw e;
              });
            case 4:
              response = _context3.sent;
              values = _toConsumableArray(response.data.value);
              _this8.thirdPartyUserList = [];
              values.forEach(function (user) {
                var _user$delivery_addres, _listUserGroups$find;
                var fullName = !isHolding(_this8.loggedUserData) ? getFullNameUser(user) + " - " + user.delivery_address.country.iso_code + ((_user$delivery_addres = user.delivery_address.state) !== null && _user$delivery_addres !== void 0 && _user$delivery_addres.iso_state ? "-".concat(user.delivery_address.state.iso_state) : "") + " " + ((_listUserGroups$find = listUserGroups.find(function (x) {
                  return x.id === user.user_group.toUpperCase();
                })) === null || _listUserGroups$find === void 0 ? void 0 : _listUserGroups$find.name) + " (" + user.login + ")" : getFullNameUser(user);
                _this8.thirdPartyUserList.push(_objectSpread(_objectSpread({}, user), {}, {
                  full_name: fullName,
                  name_for_file: String.replaceNonAlphaNumerics(String.removeDiacritics(getFullNameUser(user)).replace(",", ""), "_").replace(/__/g, "_").toUpperCase()
                }));
              });
              _this8.thirdPartyUserList.sort(function (a, b) {
                return a.full_name.localeCompare(b.full_name);
              });
              if (!(isConsultantOrHolding(_this8.loggedUserData) && !_this8.thirdPartyUserList.some(function (x) {
                return x.id_user == _this8.loggedUserData.idUser;
              }))) {
                _context3.next = 15;
                break;
              }
              _context3.next = 12;
              return getUserLogged();
            case 12:
              userLogged = _context3.sent;
              userLogged.full_name = isHolding(_this8.loggedUserData) ? "All group" : "Me : " + getFullNameUser(userLogged) + " - " + userLogged.delivery_address.country.iso_code + ((_userLogged$delivery_ = userLogged.delivery_address.state) !== null && _userLogged$delivery_ !== void 0 && _userLogged$delivery_.iso_state ? "-".concat(userLogged.delivery_address.state.iso_state) : "") + " " + (((_userLogged$company_n = userLogged.company_name) === null || _userLogged$company_n === void 0 ? void 0 : _userLogged$company_n.length) > 0 ? "Professional" : "Individual") + " (" + userLogged.login + ")";
              _this8.thirdPartyUserList.unshift(userLogged);
            case 15:
              _this8.isLoadingUserList = false;
            case 16:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    fetchWarehouses: function fetchWarehouses() {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _this9.isLoadingWarehouses = true;
              _this = _this9;
              _context4.next = 4;
              return request("/v1/warehouses", "post", {}, true, "api").catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to load warehouses");
                handleErrorData(_this, errorData);
                _this.isLoadingWarehouses = false;
                throw e;
              });
            case 4:
              response = _context4.sent;
              _this9.warehouses = response.data.warehouses;
              _this9.isLoadingWarehouses = false;
            case 7:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    fetchStorageLocationsForUser: function fetchStorageLocationsForUser() {
      var _this10 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var idUserTarget, continents;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _this10.isLoadingStorageLocations = true;
              _this10.storageLocationsForUser = [];
              idUserTarget = _this10.formConfig.userIdTarget ? _this10.formConfig.userIdTarget : _this10.loggedUserData.idUser;
              _context5.next = 5;
              return request("/v1/warehouses/for-user-continents/".concat(idUserTarget), "get", null, true, "api", null);
            case 5:
              continents = _context5.sent.data.value;
              _this10.storageLocationsForUser = continents.map(function (x) {
                return {
                  continent_iso2: x.continentIso2,
                  name: listContinents.find(function (c) {
                    return c.id === x.continentIso2;
                  }).display_name,
                  warehouseId: x.warehouseId
                };
              });
              _this10.isLoadingStorageLocations = false;
            case 8:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    fetchProducers: function fetchProducers() {
      var _this11 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _this11.isLoadingProducers = true;
              _this = _this11;
              _context6.next = 4;
              return request("/v1/producers/all", "post", {}, true, "api").catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to load producers.");
                handleErrorData(_this, errorData);
                _this.isLoadingProducers = true;
                throw e;
              });
            case 4:
              response = _context6.sent;
              _this11.listProducers = _toConsumableArray(response.data.value.items);
              if (_this11.isSpiritsExport) {
                _this11.listProducers = _this11.listProducers.filter(function (x) {
                  return x.isDistillery;
                });
              } else {
                _this11.listProducers = _this11.listProducers.filter(function (x) {
                  return x.isWinery;
                });
              }
              _this11.generateProducersList();
              _this11.isLoadingProducers = false;
            case 9:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    fetchImplantedCountries: function fetchImplantedCountries() {
      var _this12 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _this12.isLoadingImplantedCountries = true;
              _this = _this12;
              _context7.next = 4;
              return request("/v1/countries/protected?implantedMarket=true", "GET", null, true, "api").catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to load implanted countries", true);
                handleErrorData(_this, errorData);
                _this.isLoadingImplantedCountries = false;
                throw e;
              });
            case 4:
              response = _context7.sent;
              _this12.implantedCountries = _toConsumableArray(response.data.countries);
              _this12.listStates = _toConsumableArray(response.data.states);
              _this12.isLoadingImplantedCountries = false;
            case 8:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    fetchOriginCountriesAndRegions: function fetchOriginCountriesAndRegions() {
      var _this13 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        var _this, responseCountries, listAllCountries, responseRegions, listAllRegions, countryIds;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _this13.isLoadingOrigins = true;
              _this = _this13;
              _context8.next = 4;
              return request("/v1/countries?havingProducers=true", "post", _this.clientAppData, false, "api").catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to load countries of origin");
                handleErrorData(_this, errorData);
                _this.isLoadingOrigins = false;
                throw e;
              });
            case 4:
              responseCountries = _context8.sent;
              listAllCountries = _toConsumableArray(responseCountries.data.countries);
              _context8.next = 8;
              return request("/v1/regions", "get", null, true, "api").catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to load regions of origin");
                handleErrorData(_this, errorData);
                _this.isLoadingOrigins = false;
                throw e;
              });
            case 8:
              responseRegions = _context8.sent;
              listAllRegions = _toConsumableArray(responseRegions.data);
              if (_this13.isSpiritsExport) {
                _this13.listRegions = _toConsumableArray(listAllRegions.filter(function (x) {
                  return x.isSpiritRegion;
                }));
              } else {
                _this13.listRegions = _toConsumableArray(listAllRegions.filter(function (x) {
                  return x.isWineRegion;
                }));
              }
              countryIds = _toConsumableArray(new Set(_this13.listRegions.map(function (x) {
                return x.country.id_country;
              })));
              _this13.listCountries = listAllCountries.filter(function (x) {
                return countryIds.includes(x.id_country);
              });
              _this13.isLoadingOrigins = false;
            case 14:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }))();
    },
    changeCountry: function changeCountry() {
      this.formConfig.originRegionId = null;
      this.regenerateDisplayedLists();
    },
    changeRegion: function changeRegion() {
      this.regenerateDisplayedLists();
    },
    regenerateDisplayedLists: function regenerateDisplayedLists() {
      this.generateRegionsList();
      this.generateProducersList();
      this.cleanFilters();
    },
    cleanFilters: function cleanFilters() {
      var producerIdsAvailable = this.displayedListProducers.map(function (x) {
        return x.id;
      });
      this.formConfig.producersId = this.formConfig.producersId.filter(function (x) {
        return producerIdsAvailable.includes(x);
      });
    },
    generateRegionsList: function generateRegionsList() {
      var _this14 = this;
      this.displayedListRegions = [];
      if (this.formConfig.originCountryId) {
        this.displayedListRegions = _toConsumableArray(this.listRegions.filter(function (region) {
          return region.country.id_country === _this14.formConfig.originCountryId;
        }));
      }
    },
    generateProducersList: function generateProducersList() {
      var _this15 = this;
      if (!!this.formConfig.originCountryId) {
        if (!!this.formConfig.originRegionId) {
          this.displayedListProducers = _toConsumableArray(this.listProducers.filter(function (x) {
            return x.regionSubs.some(function (sub) {
              return sub.regionParent.country.id_country == _this15.formConfig.originCountryId && sub.regionParent.id == _this15.formConfig.originRegionId;
            });
          }));
        } else {
          this.displayedListProducers = _toConsumableArray(this.listProducers.filter(function (x) {
            return x.regionSubs.some(function (sub) {
              return sub.regionParent.country.id_country == _this15.formConfig.originCountryId;
            });
          }));
        }
      } else {
        this.displayedListProducers = _toConsumableArray(this.listProducers);
      }
    },
    exportPriceList: function exportPriceList(exportTypeId) {
      var _this16 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
        var path, data, _this16$formConfig$st, ids, _this;
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              path = "/v1/price-list";
              data = null;
              if (isAdminNotConsultant(_this16.loggedUserData) || isConsultantOrHolding(_this16.loggedUserData)) {
                data = {
                  userGroup: _this16.formConfig.userGroup,
                  countryId: _this16.formConfig.countryId,
                  stateId: (_this16$formConfig$st = _this16.formConfig.stateId) !== null && _this16$formConfig$st !== void 0 ? _this16$formConfig$st : 0,
                  userIdTarget: _this16.formConfig.userIdTarget,
                  currency: _this16.formConfig.currency,
                  productTypesId: _this16.formConfig.productTypesId,
                  productTypesIdExcluded: _this16.formConfig.productTypesIdExcluded,
                  priceRange: _this16.formConfig.priceRange
                };
                if (isAdminNotConsultant(_this16.loggedUserData)) {
                  data.isCogsColumn = _this16.formConfig.isCogsColumn;
                  data.isWineIdColumn = _this16.formConfig.isWineIdColumn;
                }
              } else if (isHolding(_this16.loggedUserData)) {
                data = {
                  userIdTarget: _this16.formConfig.userIdTarget
                };
              } else {
                data = {};
              }
              data.exportType = exportTypeId;
              data.fileName = _this16.filename;
              data.isStockOnly = _this16.formConfig.isStockOnly;
              data.origin = {
                countryId: _this16.formConfig.originCountryId,
                regionId: _this16.formConfig.originRegionId
              };
              data.producersId = _this16.formConfig.producersId;
              data.bottlings = _this16.formConfig.bottlings;
              data.search = _this16.formConfig.search;
              if (!!_this16.formConfig.locations) {
                ids = _this16.formConfig.locations.flat();
                data.locations = {
                  isDirectWineryIncluded: ids.includes(_this16.fakeDirectWineryWarehouseId),
                  warehouseIds: ids.filter(function (x) {
                    return x !== _this16.fakeDirectWineryWarehouseId;
                  })
                };
              } else {
                data.locations = null;
              }
              if (_this16.isAdminNotConsultant(_this16.loggedUserData)) {
                data.isApplyPricePostingByDefault = false;
                if (_this16.canChoosePricePosting) {
                  data.pricePostingUsaProId = _this16.formConfig.pricePostingUsaProId;
                }
              } else {
                data.isApplyPricePostingByDefault = true;
              }
              _this = _this16;
              _context11.t0 = exportTypeId;
              _context11.next = _context11.t0 === _this.exportTypesList.EXPORT_FILE.id ? 16 : _context11.t0 === _this.exportTypesList.MAIL_ATTACHMENT.id ? 19 : 22;
              break;
            case 16:
              _this.exportingStatus = _this.exportingStatusList.EXPORTING.id;
              request(path, "post", data, true, "api", "blob").then(function (response) {
                _this.exportingStatus = _this.exportingStatusList.EXPORT_COMPLETED.id;
                fileDownload(response.data, _this.filename, "application/xlsx");
              }).catch(/*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee9(e) {
                  var errorData;
                  return _regeneratorRuntime().wrap(function _callee9$(_context9) {
                    while (1) switch (_context9.prev = _context9.next) {
                      case 0:
                        _context9.next = 2;
                        return Object.blobExToJsonEx(e);
                      case 2:
                        e = _context9.sent;
                        errorData = getErrorData(e, _this.managedExceptions);
                        _this.$toasted.show(errorData.message, {
                          type: errorData.type
                        });
                        _this.exportingStatus = _this16.exportingStatusList.ERROR.id;
                      case 6:
                      case "end":
                        return _context9.stop();
                    }
                  }, _callee9);
                }));
                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }());
              return _context11.abrupt("break", 22);
            case 19:
              _this.exportingStatus = _this.exportingStatusList.WAITING_EMAIL.id;
              request(path, "post", data, true, "api").then(function (_) {
                _this.closeTab();
              }).catch(/*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee10(e) {
                  var errorData;
                  return _regeneratorRuntime().wrap(function _callee10$(_context10) {
                    while (1) switch (_context10.prev = _context10.next) {
                      case 0:
                        errorData = getErrorData(e, _this.managedExceptions);
                        _this.$toasted.show(errorData.message, {
                          type: errorData.type
                        });
                        _this.exportingStatus = _this16.exportingStatusList.ERROR.id;
                      case 3:
                      case "end":
                        return _context10.stop();
                    }
                  }, _callee10);
                }));
                return function (_x2) {
                  return _ref2.apply(this, arguments);
                };
              }());
              return _context11.abrupt("break", 22);
            case 22:
            case "end":
              return _context11.stop();
          }
        }, _callee11);
      }))();
    },
    closeTab: function closeTab() {
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              window.close();
            case 1:
            case "end":
              return _context12.stop();
          }
        }, _callee12);
      }))();
    },
    applyCountryDefaultCurrency: function applyCountryDefaultCurrency() {
      this.generateStatesList();
      if (this.canChooseCurrency) {
        this.formConfig.currency = this.countryDefaultCurrency;
      } else {
        this.formConfig.currency = null;
      }
    },
    generateStatesList: function generateStatesList() {
      this.formConfig.stateId = null;
      this.displayedListStates = [];
      if (this.formConfig.countryId) {
        for (var state in this.listStates) {
          if (this.listStates[state].id_country === this.formConfig.countryId) {
            this.displayedListStates.push(this.listStates[state]);
          }
        }
      }
    },
    fetchPricePostingUsaProUsables: function fetchPricePostingUsaProUsables() {
      var _this17 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
        var params, _this, response, noOne;
        return _regeneratorRuntime().wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              _this17.gettingPricePostingUsaProPosted.isPending = true;
              params = "?onlyStillAvailable=true";
              _this = _this17;
              _context13.next = 5;
              return request("/v1/price-posting/usable".concat(params), "get", null, true, "api", null).catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to get available price postings");
                handleErrorData(_this, errorData);
                _this.gettingPricePostingUsaProPosted.isPending = false;
                throw e;
              });
            case 5:
              response = _context13.sent;
              noOne = {
                id: 0,
                applicationDateString: isAdminNotConsultant(_this17.loggedUserData) ? "Future date | Live pricing" : "Future date"
              };
              _this17.gettingPricePostingUsaProPosted.items = [noOne].concat(_toConsumableArray(response.data.value.map(function (x) {
                return _objectSpread(_objectSpread({}, x), {}, {
                  applicationDateString: new Date(x.applicationDate).formatStringMonth() + (x.status == pricePostingStatusList.DRAFT.id ? " (draft)" : "")
                });
              })));
              _this17.gettingPricePostingUsaProPosted.isPending = false;
            case 9:
            case "end":
              return _context13.stop();
          }
        }, _callee13);
      }))();
    },
    isAdminNotConsultant: isAdminNotConsultant,
    isConsultantOrHolding: isConsultantOrHolding,
    isConsultantNotHolding: isConsultantNotHolding,
    isHolding: isHolding,
    isSalesman: isSalesman,
    filterVAutocomplete: filterVAutocomplete,
    filterDecimal2digitsKey: filterDecimal2digitsKey
  }
};